import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface FigLabelProps {
    fig: string
    title: string
    detail: string
    note?: string
    mark?: boolean
    className?: string
}

/**
 * The small figure label every section carries in its top left, with a dim mono line under it.
 */
export const FigLabel: FC<FigLabelProps> = ({ fig, title, detail, note, mark = true, className }): ReactNode => {
    return (
        <div data-ruler-mark={mark ? fig : undefined} className={cn('reveal-fade', className)}>
            <p className='hud text-ink'>
                Fig. {fig} / {title} / {detail}
            </p>

            {note && (
                <p className='hud text-mute'>
                    {note}
                </p>
            )}
        </div>
    )
}
